import { RequireAuth } from "../../fabrix/components/authentication/auth-validation";
import { ModuleInfo } from "fabrix/types";
import translationJson from "./translations.json";
import { icons } from "./icons";

const moduleRoutes = (): ModuleInfo => {
  let routes = {
    path: "/afs/",
    label: "AFS Workbench",
    name: "afs",
    id: "a0f2b8c4-5d3e-4b1c-8f7d-6a9e5f3b2c15",
    lazy: async () => {
      const Page = (await import("./index")).default;
      return {
        element: (
          <RequireAuth roles={["admin", "system-admin"]}>
            <Page />
          </RequireAuth>
        ),
      };
    },
    translations: translationJson,
    icons: icons,
    children: [
      {
        order: 0,
        path: "/afs/",
        label: "AFS Landing",
        name: "landing",
        icon: "afs-landing",
        hide: true,
        id: "d22fda5d-3318-4012-9ac5-71231234",
        lazy: async () => {
          const Page = (await import("./routes/landing")).default;
          return {
            element: (
              <RequireAuth>
                <Page />
              </RequireAuth>
            ),
          };
        },
      },
      {
        path: "/afs/dashboard/",
        order: 1,
        label: "AFS Dashboard",
        name: "dashboard",
        icon: "afs-dashboard",
        hide: true,
        id: "d22fda5d-3318-4012-9ac5-71340234",
        lazy: async () => {
          const Page = (await import("./routes/dashboard")).default;
          return {
            element: (
              <RequireAuth>
                <Page />
              </RequireAuth>
            ),
          };
        },
      },
      // {
      //   path: "/afs/workbooks/",
      //   order: 2,
      //   label: "AFS Workbooks",
      //   icon: "afs-main",
      //   name: "afs-workbooks",
      //   hide: false,
      //   id: "112fda5d-9818-4012-9ac5-7239243h23",
      //   lazy: async () => {
      //     const Page = (await import("./routes/workbooks")).default;
      //     return {
      //       element: (
      //         <RequireAuth>
      //           <Page />
      //         </RequireAuth>
      //       ),
      //     };
      //   },
      // },

      // {
      //   path: "/afs/scoa/",
      //   order: 2,
      //   label: "Import SCOA",
      //   icon: "afs-main",
      //   name: "afs-scoa",
      //   hide: false,
      //   id: "112fda5d-9818-4012-9ac5-71234243h23",
      //   lazy: async () => {
      //     const Page = (await import("./routes/scoa/SCOAImporter")).default;
      //     return {
      //       element: (
      //         <RequireAuth>
      //           <Page />
      //         </RequireAuth>
      //       ),
      //     };
      //   },
      // },
      {
        path: "/afs/policies/",
        order: 0,
        label: "Accounting Policies",
        name: "policies",
        icon: "afs-policies",
        hide: true,
        id: "d22fda5d-3318-4012-9ac5-9bbd1166471",
        lazy: async () => {
          const Page = (await import("./routes/policies")).default;
          return {
            element: (
              <RequireAuth>
                <Page />
              </RequireAuth>
            ),
          };
        },
      },
      {
        path: "/afs/appropriations/",
        order: 5,
        label: "Appropriations",
        name: "appropriations",
        icon: "afs-appropriations",
        hide: true,
        id: "wws2fda5d-3168-4012-9ac5-9bbd11171",
        lazy: async () => {
          const Page = (await import("./routes/approp-report/")).default;
          return {
            element: (
              <RequireAuth>
                <Page />
              </RequireAuth>
            ),
          };
        },
      },
      {
        path: "/afs/adjusted-appropriations/",
        order: 6,
        label: "Adjusted Appropriations",
        name: "adjusted-appropriations",
        icon: "afs-appropriations",
        hide: true,
        id: "b62bf0c1-8d23-4f08-a1f0-8cbb45a01d92",
        lazy: async () => {
          const Page = (await import("./routes/adjusted-appropriations")).default;
          return {
            element: (
              <RequireAuth>
                <Page />
              </RequireAuth>
            ),
          };
        },
      },
      {
        path: "/afs/trial-balance/",
        order: 4,
        label: "Trial Balance",
        name: "trial-balance",
        icon: "afs-trial-balance",
        hide: true,
        id: "c72dfa5d-8842-4fab-9ac5-9bbd1166991",
        lazy: async () => {
          const Page = (await import("./routes/trial-balance")).default;
          return {
            element: (
              <RequireAuth>
                <Page />
              </RequireAuth>
            ),
          };
        },
      },
      {
        path: "/afs/imported-trial-balance/",
        order: 4.1,
        label: "Imported TB",
        name: "imported-trial-balance",
        icon: "afs-imported-trial-balance",
        hide: true,
        id: "fe62d6ef-2a56-4eca-9a76-8dbe1df2c021",
        lazy: async () => {
          const Page = (await import("./routes/imported-trial-balance")).default;
          return {
            element: (
              <RequireAuth>
                <Page />
              </RequireAuth>
            ),
          };
        },
      },
      {
        path: "/afs/template-builder/",
        order: 4.2,
        label: "Template Builder",
        name: "template-builder",
        icon: "afs-template-builder",
        hide: true,
        id: "83d53dbe-98db-4721-b064-e63b80acb0cc",
        lazy: async () => {
          const Page = (await import("./routes/import/ImportRoute")).default;
          return {
            element: (
              <RequireAuth>
                <Page />
              </RequireAuth>
            ),
          };
        },
      },
      {
        path: "/afs/import/",
        order: 4.21,
        label: "Template Builder",
        name: "import",
        icon: "afs-template-builder",
        hide: true,
        id: "f3f3fb98-e89a-4ac1-8a98-85c7f9c8cb7b",
        lazy: async () => {
          const Page = (await import("./routes/import/ImportRoute")).default;
          return {
            element: (
              <RequireAuth>
                <Page />
              </RequireAuth>
            ),
          };
        },
      },
      {
        path: "/afs/specimen/",
        order: 4.3,
        label: "AFS Conversion",
        name: "specimen",
        icon: "afs-specimen",
        hide: true,
        id: "f4ad0137-5f1e-43bc-9f35-c85692a2fb8b",
        lazy: async () => {
          const Page = (await import("./routes/specimen")).default;
          return {
            element: (
              <RequireAuth>
                <Page />
              </RequireAuth>
            ),
          };
        },
      },
      {
        path: "/afs/training-videos/",
        order: 4.31,
        label: "Training Videos",
        name: "training-videos",
        icon: "afs-specimen",
        hide: true,
        id: "e9726fd1-163a-4abc-b841-550f9f9f2e36",
        lazy: async () => {
          const Page = (await import("./components/workbench/training/TrainingVideosPage")).default;
          return { element: <RequireAuth><Page /></RequireAuth> };
        },
      },
      {
        path: "/afs/workbook-editor/",
        order: 4.37,
        label: "Workbook Editor",
        name: "workbook-editor",
        icon: "afs-template-builder",
        hide: true,
        id: "06d9ab90-d0fb-4691-a7d7-768e3fe6fb07",
        lazy: async () => {
          const Page = (await import("./routes/workbook-editor")).default;
          return {
            element: (
              <RequireAuth>
                <Page />
              </RequireAuth>
            ),
          };
        },
      },
      {
        path: "/afs/online-mcs/",
        order: 4.4,
        label: "Online MCS",
        name: "online-mcs",
        icon: "afs-online-mcs",
        hide: true,
        id: "9425b312-2c45-4b8a-a793-6d2f5dd6182d",
        lazy: async () => {
          const Page = (await import("./routes/online-mcs")).default;
          return {
            element: (
              <RequireAuth>
                <Page />
              </RequireAuth>
            ),
          };
        },
      },
      {
        path: "/afs/per/",
        order:3,
        label: "PER",
        name: "per",
        icon: "afs-per",
        hide: true,
        id: "a22fda5d-3318-4012-9ac5-9bbd1166401",
        lazy: async () => {
          const Page = (await import("./routes/per")).default;
          return {
            element: (
              <RequireAuth>
                <Page />
              </RequireAuth>
            ),
          };
        },
      },
      {
        path: "/afs/per-from-tb/",
        order: 3.1,
        label: "PER from TB",
        name: "per-from-tb",
        icon: "afs-per-imported",
        hide: true,
        id: "dbbcd155-1f0d-4b39-8b18-8b9f0e093ca5",
        lazy: async () => {
          const Page = (await import("./routes/per-from-tb")).default;
          return {
            element: (
              <RequireAuth>
                <Page />
              </RequireAuth>
            ),
          };
        },
      },
      {
        path: "/afs/admin-setup/",
        order: 8,
        label: "Admin Setup",
        name: "admin-setup",
        icon: "afs-settings",
        hide: true,
        id: "ad12fda5d-3318-4012-9ac5-9bbd1166402",
        lazy: async () => {
          const Page = (await import("./routes/admin-setup")).default;
          return {
            element: (
              <RequireAuth>
                <Page />
              </RequireAuth>
            ),
          };
        },
      },
      {
        path: "/afs/pos/",
        order: 6,
        label: "POS",
        name: "pos",
        icon: "afs-pos",
        hide: true,
        id: "c22fda5d-3318-4012-9ac5-9bbd1166501",
        lazy: async () => {
          const Page = (await import("./routes/pos")).default;
          return {
            element: (
              <RequireAuth>
                <Page />
              </RequireAuth>
            ),
          };
        },
      },
      // {
      //   path: "/afs/import-tb-prev/",
      //   order: 4,
      //   label: "Prev Yr Trail Balance",
      //   name: "import-tb-prev",
      //   icon: "afs-import",
      //   hide: false,
      //   id: "d22fda5d-3318-4072-9ac5-9b13251271",
      //   lazy: async () => {
      //     const Page = (await import("./routes/prev-tb")).default;
      //     return {
      //       element: (
      //         <RequireAuth>
      //           <Page />
      //         </RequireAuth>
      //       ),
      //     };
      //   },
      // },
      // {
      //   path: "/afs/import-tb/",
      //   order: 4,
      //   label: "Import TB",
      //   name: "import-tb",
      //   icon: "afs-import",
      //   hide: false,
      //   id: "d22fda5d-3318-4012-9ac5-9bbd1166771",
      //   lazy: async () => {
      //     // Reverted to original Trial Balance import page (previously temporarily showing new appropriations)
      //     const Page = (await import("./components/trail-balance-import")).default;
      //     return {
      //       element: (
      //         <RequireAuth>
      //           <Page />
      //         </RequireAuth>
      //       ),
      //     };
      //   },
      // },

      // {
      //   path: "/afs/statements/",
      //   order: 6,
      //   label: "Statements",
      //   name: "statements",
      //   icon: "afs-statements",
      //   hide: false,
      //   id: "d22fda5d-3318-4012-9ac5-9bbd2352771",
      //   lazy: async () => {
      //     const Page = (await import("./routes/fin-statements")).default;
      //     return {
      //       element: (
      //         <RequireAuth>
      //           <Page />
      //         </RequireAuth>
      //       ),
      //     };
      //   },
      // },
      // {
      //   path: "/afs/notes/",
      //   order: 7,
      //   label: "Notes",
      //   name: "notes",
      //   icon: "afs-notes",
      //   hide: false,
      //   id: "d22fda5d-3318-4012-9ac5-9bbd12122771",
      //   lazy: async () => {
      //     const Page = (await import("./routes/notes")).default;
      //     return {
      //       element: (
      //         <RequireAuth>
      //           <Page />
      //         </RequireAuth>
      //       ),
      //     };
      //   },
      // },
      // {
      //   path: "/afs/submit/",
      //   order: 8,
      //   label: "Submissions",
      //   name: "submissions",
      //   icon: "afs-submit",
      //   hide: false,
      //   id: "d22fda5d-3318-4012-9ac5-9b1232122771",
      //   lazy: async () => {
      //     const Page = (await import("./routes/submit")).default;
      //     return {
      //       element: (
      //         <RequireAuth>
      //           <Page />
      //         </RequireAuth>
      //       ),
      //     };
      //   },
      // },
      // {
      //   path: "/afs/audit/",
      //   order: 9,
      //   label: "Audit Log",
      //   name: "audit-log",
      //   icon: "afs-audit",
      //   hide: false,
      //   id: "d212da5d-3318-4012-9ac5-9b1241122771",
      //   lazy: async () => {
      //     const Page = (await import("./routes/audit")).default;
      //     return {
      //       element: (
      //         <RequireAuth>
      //           <Page />
      //         </RequireAuth>
      //       ),
      //     };
      //   },
      // },
    ],
  };
  return routes;
};

export default moduleRoutes;
